/* eslint-disable */
/** http://datav.aliyun.com/tools/atlas/#&lat=30.343372698262712&lng=106.25395026667131&zoom=4.5 */
import echarts from 'echarts'
import china from './china.json'
import { titleColor } from './common'
echarts.registerMap('china', china)

export default (data = []) => {
  const maxCount = Math.max(...Object.entries(data).map(([name, count]) => count));
  const values = Object.entries(data).map(([name, count]) => {
    const areaColor = `rgba(33, 150, 243, ${count / maxCount})`;
    console.log(areaColor, count, maxCount, data);
    return {
      name,
      value: count,
      selected: true,
      label: {
        show: true,
        fontSize: 20,
        color: '#f5f5f5'
      },
      emphasis: {
        itemStyle: {
          areaColor,
          fontSize: 20
        }
      }
    };
  });
  console.log('map', values);
  return {
    title: {
      text: '门店分布情况',
      textStyle: {
        color: titleColor,
        fontSize: 30
      }
    },
    tooltip: {
      trigger: 'item',
      textStyle: {
        fontSize: 30
      },
      formatter: (params, ticket, callback) => {
        return `${params.name}: ${data[params.name] || 0}`
      }
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      data: ['']
    },
    left: '10%',
    right: '10%',
    top: '10%',
    series: [
      {
        name: '',
        type: 'map',
        mapType: 'china',
        center: [115.97, 29.71],
        selectedMode: 'multiple',
        layoutCenter: ['65%', '60%'],
        layoutSize: '120%',
        textStyle: {
          color: '#f5f5f5'
        },
        itemStyle: {
          areaColor: 'rgba(0, 0, 0, .1)',
          borderColor: '#fff',
        },
        emphasis: {
          itemStyle: {
            areaColor: 'rgba(33, 150, 243, .4)',
            color: '#fff'
          },
          label: {
            show: true,
            fontSize: 20,
            color: '#f5f5f5'
          }
        },
        showLegendSymbol: true,
        data: values
      }]
  }
}